import { createFileRoute } from '@tanstack/react-router';
import { PersonJourneysRoute } from './-route-wrappers';

/** The person profile's Journeys tab at its own URL (FPS-2783). */
function PersonJourneysIndexRoute() {
  return <PersonJourneysRoute />;
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/people/$personId/journeys/')({
  component: PersonJourneysIndexRoute,
});
